import * as yup from "yup";

export const userProfileValidation = yup.object({
  email: yup.string().email('Invalid email format').required("Email is required"),
  username: yup.string().required("Username is required"),
  password: yup.string()
    .required('Password is required')
    .test('min-length', 'Password should contain at least 8 characters', (val = '') => val.length >= 8)
    .test('max-length', 'Password is too long', (val = '') => val.length <= 64)
    .test('lowercaseUppercase', 'Password should be a mixture of lower case and upper case letters, numbers and special characters (#, ?, !)',
      (val = '') => /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(val)),
  confirmPassword: yup.string().required('Please, enter the same password')
    .oneOf([yup.ref('password'), null], 'Please, enter the same password'),
});